import { parseQuery } from '@calendly/http-tools'

export const shouldHideDossierSelector = () => (
  parseInt(parseQuery(window.location.search).hide_landing_page_details, 10) === 1
)
